import * as React from 'react';
import moment from 'moment';
import {
    Card,
    Box,
    Stack,
    Typography,
    IconButton,
    Tooltip, Tab,
} from '@mui/material';
import ContactsIcon from '@mui/icons-material/Contacts';
import {
    useGetList,
    SimpleList,
    useGetIdentity,
    TextField,
    NumberField,
    Datagrid,
    List,
    InfiniteList, Count, useInfiniteGetList, DateField, useListController, FunctionField
} from 'react-admin';

import ControlPointIcon from '@mui/icons-material/ControlPoint';
import { Link } from 'react-router-dom';

const DateFormat = ({  record, source }) => {
    const date = moment.unix(record[source] / 1000);
    return <span >{date.format('YYYY-MM-DD')}</span>;
};

export const Claims = ({ options }) => {
    const { identity } = useGetIdentity();

    const { setFilters, filterValues } = useListController();

    const {
        data: claimsData,
        total: claimsTotal,
        isPending: claimsLoading,
    } = useGetList(
        'claims',
        {

            sort: { field: 'clientname', order: 'ASC' },
            filter: { clientnumber: options.clientId , startDate: filterValues.start_date, endDate: filterValues.end_date, pharmacies: filterValues.pharmacies, tpas:filterValues.tpas, clients:filterValues.clients},
            pagination: { page: 1, perPage: 10000 },

        }
    );


    return (
        <Box>

            <Box position="sticky"   textAlign="center">
                <Tab
                    sx={{ justifyContent: 'left', textTransform: 'capitalize', opacity: '1'}}
                    label={
                        <span >
                            Claims <span style={{ borderRadius: '16px',   padding: '2px 8px', lineHeight: 'inherit', backgroundColor:'rgba(210, 100, 80, 1)' , color: 'white' }} >({claimsTotal}) </span>
                            </span>
                    }
                />


            </Box>


        <InfiniteList perPage={10} exporter={false}>
            <div style={{ height: '200px', overflowY: 'auto' }}>
        <Datagrid data={claimsData}
                  total={claimsTotal}
                  isPending={claimsLoading}
                  resource="claims" optimized  rowClick={() => {}}
                  sx={{background: 'antiquewhite', textTransform: 'capitalize'}} bulkActionButtons={false}
        >
            <FunctionField
                label="Process Date"
                render={record => <DateFormat record={record} source={'financial_cutoff_date'} />}
            />
            <FunctionField
                label="Fill Date"
                render={record => <DateFormat record={record} source={'fill_date'} />}
            />
            <TextField sortable={false} source="rx_number" />
            <TextField sortable={false} source="member_id" />
            <TextField sortable={false} source="ndc" />
            <TextField sortable={false} source="drug_name" />
            <NumberField sortable={false} source="quantity"/>
            <TextField sortable={false} source="days_supply" />
            <TextField sortable={false} source="claim_cost" />
            <TextField sortable={false} source="patient_liability" />
            <NumberField sortable={false} label="Plan Paid"
                         source="plan_paid"
                         options={{
                             style: 'currency',
                             currency: 'USD',
                         }}
            />
            {/*<TextField sortable={false} source="cardholder_name" />
            <DateField sortable={false} source="member_dob" showDate/>
            <TextField source="member_address" />
                                    <TextField source="member_city" />
                                    <TextField source="member_state" />
                                    <TextField source="member_zip" />

            <TextField sortable={false} source="pharmacy_name" />
            <TextField sortable={false} source="pharmacy_npi" />
            <NumberField sortable={false}  label="Paid"
                         source="patient_paid"
                         options={{
                             style: 'currency',
                             currency: 'USD',
                         }}
            />
            <NumberField sortable={false} label="Plan Paid"
                         source="plan_paid"
                         options={{
                             style: 'currency',
                             currency: 'USD',
                         }}
            />

            <TextField sortable={false} source="financial_cutoff_date" label="Process Date"/>
            <TextField sortable={false} source="fill_date" />
            <NumberField sortable={false} label="Claim Number"
                         source="claim_number"
            />
             <TextField sortable={false} source="member_id" label="Patient ID"/>
             <TextField sortable={false} source="drug_name" label="Drug Name"/>
             <TextField sortable={false} source="days_supply" label="Days"/>
             <NumberField sortable={false} label="Total Cost"
                         source="claim_cost"
                         options={{
                             style: 'currency',
                             currency: 'USD',
                         }}
              />
              <TextField sortable={false} source="patient_liability" label="Copay"/>
              <TextField sortable={false} source="plan_paid" label="Plan Paid"/>
            */}

        </Datagrid>
            </div>
        </InfiniteList>
        </Box>
        /*<Stack>
            <Box display="flex" alignItems="center" mb={1}>
                <Box mr={1} display="flex">
                    <ContactsIcon color="disabled" fontSize="medium" />
                </Box>
                <Typography variant="h5" color="textSecondary">
                    Hot Contacts
                </Typography>
                <Tooltip title="Create contact">
                    <IconButton
                        size="small"
                        sx={{
                            color: 'text.secondary',
                            ml: 'auto',
                        }}
                        component={Link}
                        to="/contacts/create"
                    >
                        <ControlPointIcon fontSize="inherit" color="primary" />
                    </IconButton>
                </Tooltip>
            </Box>
            <Card
                sx={{
                    '& .MuiCardContent-root': {
                        padding: '16px !important',
                    },
                }}
            >
                <SimpleList<Contact>
                    linkType="show"
                    data={contactData}
                    total={contactTotal}
                    isPending={contactsLoading}
                    resource="contacts"
                    primaryText={contact =>
                        `${contact.first_name} ${contact.last_name}`
                    }
                    secondaryText={contact => (
                        <>
                            {contact.title} at {contact.company_name}
                        </>
                    )}
                    leftAvatar={contact => <Avatar record={contact} />}
                    dense
                    empty={
                        <Box p={2}>
                            <Typography variant="body2" gutterBottom>
                                Contacts with a "hot" status will appear here.
                            </Typography>
                            <Typography variant="body2">
                                Change the status of a contact by adding a note
                                to that contact and clicking on "show options".
                            </Typography>
                        </Box>
                    }
                />
            </Card>
        </Stack>*/
    );
};
